import React from "react";
import get from "lodash/get";
import has from "lodash/has";
import set from "@rill/set";
import size from "lodash/size";
import defaults from "lodash/defaults";
import AddSecondaryMovementModal from "../../../parts/modals/add-secondary-movement";
import EditPrimaryMovement from "../../../parts/modals/edit-primary-movement";
import AddOtherExerciseModal from "../../../parts/modals/add-other-exercise";
import JWPlayerVideoModal from "../../../parts/modals/jwplayer-video";
import ExerciseLibraryComponent from "./ExerciseLibraryComponent";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

function View(props, { locals }) {
  const {
    query,
    activeUser,
    query: { type },
    fromMetric,
    withWeight,
  } = locals;

  let primary = query.primary;

  const secondaries = get(activeUser, `exerciseLibrary.${primary}`) || [];

  const primaryRepMax = withWeight(
    activeUser.units === "imperial"
      ? fromMetric(activeUser.repMaximums[primary])
      : activeUser.repMaximums[primary],
    activeUser.units
  );

  return (
    <ExerciseLibraryComponent
      type={type}
      primary={primary}
      primaryRepMax={primaryRepMax}
      secondaries={secondaries}
      withWeight={withWeight}
      fromMetric={fromMetric}
      activeUser={activeUser}
      locals={locals}
      athlete={locals.activeUser}
      query={locals.query}
    />
  );
}

const ExerciseLibraryController = (app) => {
  app.get(
    "/exercise-library",
    set("heading", "Exercise Library"),
    ({ res, req, locals }) => {
      const modal = get(req.query, "modal", {});
      const { athlete, activeUser, query, activeUserToRequest } = locals;
      const user = athlete || activeUser;
      const isNew = !has(query, "modal.index");
      const libraryAssistant = get(user, `exerciseLibrary.assistant`) || [];
      const indexAssistant = get(query, "modal.index", size(libraryAssistant));
      const primary = get(query, "modal.primary", "squat");
      const library = get(user, `exerciseLibrary.${primary}`) || [];
      const index = get(query, "modal.index", size(library));

      const intensityMeasure =
        get(activeUserToRequest, "intensityMeasure", "rpe") === "rpe"
          ? "RPE"
          : "RiR";
      const isRiR = intensityMeasure === "RiR";

      locals.modal = {
        "add-secondary-movement": (
          <AddSecondaryMovementModal
            isNew={isNew}
            library={library}
            index={index}
            athlete={athlete}
            primary={primary}
            user={user}
          />
        ),
        "edit-primary-movement": (
          <EditPrimaryMovement
            query={locals.query}
            activeUserToRequest={locals.activeUser}
            athlete={locals.athlete}
          />
        ),
        "add-other-exercise": (
          <AddOtherExerciseModal
            isNew={isNew}
            library={libraryAssistant}
            index={indexAssistant}
            athlete={athlete}
            intensityMeasure={intensityMeasure}
            isRiR={isRiR}
          />
        ),
        "exercise-set-video": <JWPlayerVideoModal mediaId={query.mediaId} />,
        "activity-feed": <ActivityDrawer />,
      }[modal.type];

      defaults(req.query, { primary: "squat", type: "powerlifting" });
      res.body = <View />;
    }
  );
};

export default ExerciseLibraryController;
